import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { generateQueryParams } from "../../lib/utils";
import { ApisSuccess } from "./allcus";
const initialState = {
  page: 0,
  rowsPerPage: 10,
  totalGames: 0,
  data: [],
  filters: {},
  loading: false,
  approving: {},
  error: null,
};

const CreateGameSlice = createSlice({
  name: "CreateGs",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.load = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload.games;
      state.totalGames = action.payload.totalGames;
      state.loading = false;
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setApproving: (state, action) => {
      state.approving = action.payload;
    },
    updateGame: (state, action) => {
      const index = state.data.findIndex((r) => r._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = action.payload;
        state.approving = {};
      }
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    requestFailure: (state, action) => {
      state.load = false;
      state.error = action.payload;
      state.data = [];
    },
  },
});

// Actions
export const {
  requestStart,
  ApiSuccess,
  requestFailure,
  setApproving,
  setFilters,
  setPage,
  setRowsPerPage,
  updateGame,
  setData,
} = CreateGameSlice.actions;

export const CreateGSlice = (page, limit, filters) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.get(
      `/private/backend/creategames?${generateQueryParams({
        ...filters,
        page,
        limit,
      })}`
    );
    dispatch(ApiSuccess(response.data));
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
    dispatch(setApproving(false));
  }
};

export const UpdateGameStatus = (data) => async (dispatch) => {
  try {
    // TODO:  data=userid, gameid, slug, name, generate;
    dispatch(setApproving(data));

    const response = await axios.post(`/private/backend/creategames`, data);
    dispatch(updateGame(response.data));
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(setApproving({}));
  }
};
export const UpdateUserName = (data) => async (dispatch) => {
  try {
    // TODO:  data=userid, gameid, slug, name;
    // dispatch(requestStart());
    const response = await axios.put(`/private/backend/creategames`, data);
    dispatch(updateGame(response.data));
    toast.info("Username updated successfully!");
    return null;
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    return null;
  }
};
export const RemoveGame = (data) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.post(`/private/backend/remove`, data);
    dispatch(ApisSuccess(response.data));
    dispatch(ApiSuccess(response.data));
    toast.info("Game rejected successfully!");
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default CreateGameSlice.reducer;
